<template>
  <div id="login_container_feishu" v-if="isProdEnv"></div>
</template>
<script>
import Cookies from 'js-cookie'
import { on, off } from 'sk-ui/lib/utils/util'

export default {
  name: 'wspToolFeishuLogin',
  data() {
    return {
      //isProdEnv: window.location.host.includes('.ruijie.com.cn'),
      isProdEnv: true,
      loading: false,
      wspToolClientId: null
    }
  },
  created() {
    var query = this.$route.query
    //获取采集工具的ID
    this.wspToolClientId = query.wspToolClientId
    const url = window.location.href
    if (url.includes('url=')) {
      const myUrl = new URL(url)
      const params = new URLSearchParams(myUrl.hash.split('?')[1])
      const urlParam = params.get('url')
      Cookies.set('nextUrl', urlParam)
    }
    Cookies.set('wspToolClientId', this.wspToolClientId)
  },
  mounted() {
    this.$store.dispatch('CloseAllNotification')
    if (this.isProdEnv) {
      var go_to = 'http://wsp.ruijie.com.cn/wsptool/feishu/loginSuccess'
      var goto =
        'https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a56b3651d938d013&redirect_uri=' +
        go_to +
        '&response_type=code&state=STATE'
      // eslint-disable-next-line no-undef
      var QRLoginObj = QRLogin({
        id: 'app',
        goto: goto,
        width: '300',
        height: '300' //可选的，二维码html标签的style属性
      })

      this.calculateQRCodeSize()

      var handleMessage = function(event) {
        // 使用 matchOrigin 和 matchData 方法来判断 message 和来自的页面 url 是否合法
        if (QRLoginObj.matchOrigin(event.origin) && QRLoginObj.matchData(event.data)) {
          var loginTmpCode = event.data.tmp_code
          // 在授权页面地址上拼接上参数 tmp_code，并跳转
          window.location.href = `${goto}&tmp_code=${loginTmpCode}`
        }
      }
      if (typeof window.addEventListener != 'undefined') {
        window.addEventListener('message', handleMessage, false)
      } else if (typeof window.attachEvent != 'undefined') {
        window.attachEvent('onmessage', handleMessage)
      }
    }

    on(document, 'keydown', this.handleKeydown)
  },
  beforeDestroy() {
    off(document, 'keydown', this.handleKeydown)
  },
  methods: {
    calculateQRCodeSize() {
      // 获取屏幕宽度和高度
      //const screenWidth = window.innerWidth
      //const screenHeight = window.innerHeight

      // 计算屏幕的像素密度
      //const pixelDensity = Math.sqrt(screenWidth * screenWidth + screenHeight * screenHeight) / Math.sqrt(1920 * 1080)

      //var sc = pixelDensity / 1.5

      // 根据屏幕像素密度调整二维码尺寸
      var iframe = document.getElementsByTagName('iframe')

      iframe[0].style.transform = 'scale(0.80)'
    },

    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('LoginByUsername', this.loginForm)
            .then(() => {
              this.$router.push({ path: '/dashboard' })
            })
            .catch(e => {
              this.loading = false
              throw e
            })
        }
      })
    },
    handleKeydown(e) {
      const keyCode = e.keyCode
      if (keyCode === 13 && !this.loading) {
        this.handleLogin()
      }
    }
  }
}
</script>

<style>
#app iframe {
  border: 0 !important;
  object-fit: contain;
}
#app {
  margin: auto;
  justify-content: center;
  display: flex;
  align-items: center;
}
</style>
